import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
// import HomeView from '../views/HomeView.vue'
import store from "@/store";
import { useMessage } from "@/hooks/useMessage";
// 导入进度条插件
import useNProgress from "@/hooks/useNProgress";
const NProgress = useNProgress();

// 页面布局组件
const Layout_mw = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/des_mw.vue");
const Layout_tes = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/des_tes.vue");
const Layout_mecs = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/mecs.vue");
const Layout_admin = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/admin.vue");

// 对于权限管理，刚开始路由只加载，不需要权限的路由、比如：登录、404、这些无关紧要的路由
// 对于这些需要权限的路由，我们需要根据后台返回的权限路由，通过router.addRoute()动态添加进来
const routes = [
// 默认 / 由路由守卫处理，登录后根据角色导航到对应页面
  // layout admin 系统管理后台（超级管理员专属）
  {
    path: "/admin",
    name: "layout_admin",
    component: Layout_admin,
    redirect: "/admin/platform",
    children: [],
  },
  // layout des_mw  数字化能源管理平台DEMP
  {
    path: "/des_mw/project",
    name: "layout_mw",
    component: Layout_mw,
    redirect: "/des_mw/project/map",
    children: [],
  },
  // layout des_mw 系统管理
  {
    path: "/des_mw/system",
    name: "layout_mw_system",
    component: Layout_mw,
    redirect: "/des_mw/system/user",
    children: [],
  },
  // 系统管理（公共路由，超级管理员在各平台均可访问）
  {
    path: "/system",
    name: "layout_system",
    component: Layout_mw,
    redirect: "/system/user",
    children: [],
  },
  {
    path: "/des_mw",
    name: "des_mw",
    component: () => import("@/views/mw_views/projectList.vue"),
  },
  // layout  MECS
  {
    path: "/mecs/project",
    name: "layout_mecs",
    component: Layout_mecs,
    redirect: "/mecs/project/map",
    children: [],
  },
  // layout  MECS 系统管理
  {
    path: "/mecs/system",
    name: "layout_mecs_system",
    component: Layout_mecs,
    redirect: "/mecs/system/user",
    children: [],
  },
  {
    path: "/mecs",
    name: "mecs",
    component: () => import("@/views/mecs_views/projectList.vue"),
  },
  // layout des_tes
  {
    path: "/des_tes/project",
    name: "layout_tes",
    component: Layout_tes,
    redirect: "/des_tes/project/map",
    children: [],
  },
  {
    path: "/des_tes/system",
    name: "layout_tes_system",
    component: Layout_tes,
    redirect: "/des_tes/system/user",
    children: [],
  },
  {
    path: "/des_tes",
    name: "des_tes",
    component: () => import("@/views/tes_views/projectList.vue"),
  },
  // 所有软件平台platform - 重定向到管理后台的平台总览
  {
    path: "/platform",
    redirect: "/admin/platform",
  },
  // 帮助中心（独立页面，不在项目路由中）
  {
    path: "/help",
    name: "help",
    component: () => import("@/views/help/help.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/Login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/Login/Register.vue"),
  },
  // Error
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("@/views/Error/404.vue"),
  },
];
// 创建路由
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局导航前置守卫
router.beforeEach((to, from, next) => {
  // 开启进度条动画
  NProgress.start();
  // 启动时加载系统 Logo（只请求一次，后续由 localStorage 缓存）
  if (!store.state.layout.logoUrl) {
    store.dispatch("layout/fetchLogo");
  }
  const token = store.state.user.token;
  if (to.name !== "login" && to.name !== "register") {
    if (!token) {
      // 返回到登录页
      next({ name: "login" });
    } else {
      // 页面刷新，重新加载权限路由
      if (!store.state.user.isDynamicAddedRoute) {
        store.dispatch("user/loadAsyncRoute").then(() => {
          // 加载完路由后，处理根路径重定向
          if (to.path === "/" || to.path === "") {
            const roles = store.state.user.userInfo.roles || [];
            const isSysAdmin = roles.some(r => r.role_key === '1001' || r.role_key === 'sys_admin');
            const projects = store.state.user.userInfo.projects || [];
            if (isSysAdmin) {
              next({ path: "/admin/platform", replace: true });
            } else if (projects.length > 0) {
              const pt = projects[0].project_type;
              if (pt === 1) next({ path: "/mecs", replace: true });
              else if (pt === 2) next({ path: "/des_mw", replace: true });
              else if (pt === 3) next({ path: "/des_tes", replace: true });
              else next(to.fullPath);
            } else {
              next({ path: "/login", replace: true });
            }
          } else {
            // 直接导航到目标路径
            next(to.fullPath);
          }
        });
      } else {
        // 根路径已经加载过路由，根据角色重定向
        if (to.path === "/" || to.path === "") {
          const roles = store.state.user.userInfo.roles || [];
          const isSysAdmin = roles.some(r => r.role_key === '1001' || r.role_key === 'sys_admin');
          const projects = store.state.user.userInfo.projects || [];
          if (isSysAdmin) return next({ path: "/admin/platform", replace: true });
          else if (projects.length > 0) {
            const pt = projects[0].project_type;
            if (pt === 1) return next({ path: "/mecs", replace: true });
            else if (pt === 2) return next({ path: "/des_mw", replace: true });
            else if (pt === 3) return next({ path: "/des_tes", replace: true });
          }
          return next({ path: "/login", replace: true });
        }
        // 判断是否进入项目详情页（需携带正确参数）
        if (to.path.includes("/mecs/project") || to.path.includes("/des_mw/project")) {
          if (!store.state.project.chooseProject.PROJECT_ID) {
            useMessage("请选择项目", "warning");
            if (to.path.includes("/mecs")) return next({ name: "mecs" });
            if (to.path.includes("/des_mw")) return next({ name: "des_mw" });
          }
        }
        // 系统管理后台权限校验：仅超级管理员可访问
        if (to.path.startsWith("/admin")) {
          const isSysAdmin = store.state.user.userInfo?.is_sys_admin === true;
          if (!isSysAdmin) {
            useMessage("无权访问系统管理后台", "error");
            return next({ path: "/", replace: true });
          }
        }
        next();
      }
    }
  } else {
    next();
  }
});

// 全局导航后置守卫
router.afterEach(() => {
  // 关闭进度条
  NProgress.done();
});

export default router;
